<template>
    <v-container fluid>
        <v-row no-gutters class="calendar-header">
            <v-col :cols="12">
                <v-container fluid class="ma-0 pa-0">
                    <v-row no-gutters>
                        <v-col :cols="3" class="mb-0">
                            <b class="bold d-block">Modo</b>
                            <v-radio-group v-model="modo" class="d-block ma-0">
                                <v-radio
                                    label="Consultazione"
                                    value="consultazione"
                                ></v-radio>
                                <v-radio
                                    label="Modifica"
                                    value="modifica"
                                ></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col :cols="9" class="mb-0">
                            <div class="ma-0">
                                <div style="font-weight:bold;">Scegli il periodo:</div>
                                <v-date-picker
                                    mode="date"
                                    :masks="masks"
                                    is-range
                                    @input="dateRangeChange"
                                    v-model="dateRange"
                                >
                                    <template v-slot="{ inputValue, inputEvents, isDragging }">
                                        <v-container fluid class="ma-0 pa-0">
                                            <v-row no-gutters align="center">
                                                <v-col cols="5" class="mb-0">
                                                    <div class='input-group'>
                                                        <span class="input-group-addon">Dal</span>
                                                        <input
                                                            class="form-control"
                                                            :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                                                            :value="inputValue.start"
                                                            v-on="inputEvents.start"
                                                        />
                                                        <span class="input-group-addon"><i
                                                            class="glyphicon glyphicon-calendar"></i></span>
                                                    </div>
                                                </v-col>
                                                <v-col class="mb-0 text-center"><i
                                                    class="glyphicon glyphicon-arrow-right"></i></v-col>
                                                <v-col cols="5" class="mb-0">
                                                    <div class='input-group'>
                                                        <span class="input-group-addon">Al</span>
                                                        <input
                                                            class="form-control"
                                                            :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                                                            :value="inputValue.end"
                                                            v-on="inputEvents.end"
                                                        />
                                                        <span class="input-group-addon"><i
                                                            class="glyphicon glyphicon-calendar"></i></span>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </template>
                                </v-date-picker>
                            </div>
                            <v-container fluid class="ma-0 pa-0">
                                <v-row class="ma-0 pa-0">
                                    <v-col :cols="6" class="mb-0 pl-0 pb-0">
                                        <div><b class="bold">Aule:</b></div>
                                        <v-select
                                            v-model="dataAula"
                                            :items="aule"
                                            item-text="nome"
                                            :return-object="true"
                                            attach
                                            chips
                                            multiple
                                            dense
                                            hide-details
                                            solo
                                        >
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip v-if="index < 4">
                                                    <span>{{ item.nome }}</span>
                                                </v-chip>
                                                <span
                                                    v-if="index === 4"
                                                    class="grey--text caption"
                                                >
                          (+ altri {{ (dataAula.length - 4) }} )
                        </span>
                                            </template>
                                            <template v-slot:prepend-item>
                                                <v-list-item
                                                    ripple
                                                    @click="selectAllAule"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon :color="dataAula.length > 0 ? 'indigo darken-4' : ''">
                                                            {{ iconAule }}
                                                        </v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Seleziona tutti
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-divider class="mt-2"></v-divider>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col :cols="6" class="mb-0 pr-0 pb-0">
                                        <div><b class="bold">Filtro giorni:</b></div>
                                        <v-select
                                            v-model="dataWeek"
                                            :items="weekdays"
                                            :return-object="true"
                                            attach
                                            hide-details
                                            chips
                                            item-text="name"
                                            multiple
                                            dense
                                            solo
                                            @change="dateRangeChange"
                                        >
                                            <template v-slot:prepend-item>
                                                <v-list-item
                                                    ripple
                                                    @click="selectAllDays"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon :color="dataWeek.length > 0 ? 'indigo darken-4' : ''">
                                                            {{ iconWD }}
                                                        </v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Seleziona tutti
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-divider class="mt-2"></v-divider>
                                            </template>
                                        </v-select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                    </v-row>
                    <v-row no-gutters v-if="modo==='modifica'">
                        <v-container fluid class="ma-0  pa-0">
                            <v-row no-gutters align="center">
                                <v-col cols="12" class="text-center mb-0 mt-1">
                                    <div class="warning">{{ warn }}</div>
                                </v-col>
                                <v-col cols="2" class="mb-0 pb-0 pt-1">
                                    <v-btn primary @click="mostraInfoCorso" dense class="mb-0 mt-0">
                                        <v-icon>mdi-information-outline</v-icon>
                                        Info Docenti
                                    </v-btn>
                                </v-col>
                                <v-col cols="5" class="mb-0 pb-0 pt-1">
                                    <v-autocomplete
                                        label="Modulo"
                                        attach
                                        :items="moduli"
                                        :filter="moduleFilter"
                                        :return-object="true"
                                        item-text="modulo"
                                        hide-details
                                        class="mb-0 pb-0 pt-0"
                                        v-model="current_modulo">
                                        <template v-slot:no-data>
                                            <v-list-item>
                                                <v-list-item-title>
                                                    Cerca un <strong>modulo/materia</strong>
                                                </v-list-item-title>
                                            </v-list-item>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="5" class="mb-0 pb-0 pt-1">
                                    <v-autocomplete
                                        label="Docente"
                                        class="mb-0 pb-0 pt-0"
                                        attach
                                        :return-object="true"
                                        :filter="teacherFilter"
                                        :items="docenti"
                                        hide-details
                                        item-text="full_name"
                                        v-model="current_docente">
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="6" class="mb-0 pb-0 pt-1">
                                    <v-select
                                        v-model="current_tutor"
                                        :items="tutors"
                                        item-text="name"
                                        :return-object="true"
                                        label="Tutor"
                                        clearable
                                        hide-details
                                        class="mb-0 pb-0 pt-0"
                                    ></v-select>
                                </v-col>
                                <v-col cols="6" class="mb-0 pb-0 pt-1">
                                    <v-autocomplete
                                        label="Co-Docente"
                                        v-model="current_codocente"
                                        :items="codocenti"
                                        item-text="full_name"
                                        :return-object="true"
                                        :loading="loadingCodocenti"
                                        :search-input.sync="searchCodocente"
                                        hide-no-data
                                        hide-selected
                                        hide-details
                                        clearable
                                        attach
                                        class="mb-0 pb-0 pt-0"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col :cols="12" v-if="giornate.length>0&&listRendered===true">
                <div class="calendario-wrapper" :style="'width:'+wrapWidth+';'">
                    <div class="calendario-container"
                         :style="'min-width:'+wrapWidth+';'+'width:'+(250+(countOrari*200))+'px;'">
                        <!-- calendar header -->
                        <div data-sticky-wrap="true" data-sticky data-sticky-class="sticked" data-margin-top="60"
                             class="calendar-row header bold border-bottom-1"
                             :style="'width:'+(250+(countOrari*200))+'px;'">
                            <div class="headinfo">
                                <v-btn icon small @click="mostraInfoCorso">
                                    <v-icon>mdi-information-outline</v-icon>
                                </v-btn>
                                Modo: <b>{{ modo }}</b> | Periodo: <b>dal {{ formatTime(dateRange.start) }} al
                                {{ formatTime(dateRange.end) }}</b>
                                <template v-if="modo==='modifica'&&current_modulo&&current_docente">
                                    | Modulo: <b>{{ current_modulo.modulo }} </b> - Docente:
                                    <b>{{ current_docente.full_name }}</b>
                                    <span class=""
                                          style="display:inline-block; border:1px solid #FFF;border-radius: 4px; margin:2px 10px; font-size: 14px; font-weight: normal; padding: 2px 10px;">
                                        Ore Incarico: <b>{{ current_docente.incarico_durata }}</b> |
                                        Ore Residue:  <b
                                        :class="(current_docente.left_hours<=0?'red':'')">{{
                                            current_docente.left_hours
                                        }}</b>
                                    </span>
                                </template>
                            </div>
                            <div class="cella-2 cal-primary">
                                <div>Giorno/Aula</div>
                            </div>
                            <div :cols="2" v-for="(n,lidx) in countOrari" :key="'head_time_'+lidx" class="cella-1">
                                <span class="time">
                                        <span class="time_from" :date-idx="lidx">{{ orariAtIndex(lidx) }}</span>
                                        <span class="time_space">-</span>
                                        <span class="time_to" :data-idx="n">{{ orariAtIndex(n) }}</span>
                                    </span>
                            </div>
                        </div>
                        <!-- calendar body -->
                        <template v-for="(giorno,idx) in giornate">
                            <div
                                v-if="!giorno.issunday"
                                data-sticky-wrap="true" data-sticky data-sticky-class="sticked_line"
                                data-margin-top="122"
                                :class="['daychange calendar-row flex-nowrap',idx>0?'border-top-1':'',giorno.isholiday?'holiday':'']"
                                :style="'width:'+(250+countOrari*200)+'px;z-index:'+((giorno.isholiday?0:10)+idx)">
                                <div class="cella-2 cal-primary dayhead">
                                    <h5 class=" text-left bold">
                                        <small>{{ giorno.dayWeek }}</small>
                                        &nbsp;{{ giorno.dayHuman }}
                                    </h5>
                                </div>
                                <div v-for="(_item,tmidx) in countOrari" :key="giorno.dayKey+'_head_row_tm'+tmidx"
                                     class="cella-1 dayhead" v-if="!giorno.issunday">
                                    <!-- (eventuali tool o indisponibilità docente? ) -->
                                    <div class="aula infodisponibilita">
                                        <span v-if='availability[giorno.dayKey+" "+orariAtIndex(tmidx)]'
                                              :class="['not_available_line',availability[giorno.dayKey+' '+orariAtIndex(tmidx)].kind]">
                                                    <span
                                                        v-if="availability[giorno.dayKey+' '+orariAtIndex(tmidx)].kind==='corso'"
                                                        class="corso text--danger"
                                                        v-tooltip="availability[giorno.dayKey+' '+orariAtIndex(tmidx)].docente+' assegnato/a a '+availability[giorno.dayKey+' '+orariAtIndex(tmidx)].corso">
                                                            <i class="glyphicon glyphicon-alert"></i>
                                                    </span>
                                        </span>
                                        <span
                                            v-if="teacherplanning.length>0&&isTeacherPlan(giorno.dayKey,orariAtIndex(tmidx))"
                                            style="margin-left: 10px;">
                                            <span class="corso text--warning"
                                                  v-tooltip="'Il docente potrebbe non essere disponibile per questo giorno/orario'">
                                                <i class="glyphicon glyphicon-ban-circle"></i>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <template v-for="(aula, ida) in dataAula" v-if="!giorno.issunday&&!giorno.isholiday">
                                <div v-if="ida===0" :class="['daychange calendar-row ',idx>0?'border-top-1':'']"
                                     :style="'width:'+(250+(countOrari*200))+'px;'">
                                    <div class="cella-2 cal-primary">
                                        <div class="aula headcell activableCell">Aula non specificata</div>
                                        <div class="aula-line empty">&nbsp;</div>
                                    </div>
                                    <div v-for="(_item,iTimedx) in countOrari" :key="idx+'_'+ida+'row_'+iTimedx"
                                         class="cella-1 activableCell">
                                        <div class="aula celladocente noaula"
                                             :data-dayKey="giorno.dayKey"
                                             :data-timeKey="iTimedx"
                                             :data-timeValue="orariAtIndex(iTimedx)"
                                             v-on:click="impostaDocente(giorno,orariAtIndex(iTimedx),0)">
                                            <div
                                                :class="['cella',(giorno.issunday===false&&giorno.isholiday===false&&modo==='modifica'?'active':'')]"
                                                v-if='calendario[giorno.dayKey+" "+orariAtIndex(iTimedx)+" "+0]'>
                                                <span class="modulo inm"
                                                      v-if='calendario[giorno.dayKey + " " + orariAtIndex(iTimedx)+" "+0].modulo&&
                                                          calendario[giorno.dayKey + " " + orariAtIndex(iTimedx)+" "+0].modulo.modulo'>
                                                {{
                                                        calendario[giorno.dayKey + " " + orariAtIndex(iTimedx) + ' ' + 0].modulo.modulo
                                                    }}
                                                </span>
                                                <span class="docente ind"
                                                      v-if="calendario[giorno.dayKey + ' ' + orariAtIndex(iTimedx)+' '+0].docente">
                                                {{
                                                        calendario[giorno.dayKey + " " + orariAtIndex(iTimedx) + ' ' + 0].docente.full_name
                                                    }}
                                                </span>
                                                <span class="tutor" v-if="calendario[giorno.dayKey + ' ' + orariAtIndex(iTimedx)+' '+0].tutor">
                                                    Tutor: <span>{{calendario[giorno.dayKey + " " + orariAtIndex(iTimedx) + ' ' + 0].tutor.full_name}}</span>
                                                </span>
                                                <span class="codocente" v-if="calendario[giorno.dayKey + ' ' + orariAtIndex(iTimedx)+' '+0].codocente">
                                                    Co-docente: <span>{{calendario[giorno.dayKey + " " + orariAtIndex(iTimedx) + ' ' + 0].codocente.full_name}}</span>
                                                </span>

                                            </div>
                                            <div v-else :class="['cella',(modo==='modifica'?'empty-active':'')]">
                                                <span class="empty-type" v-if="modo==='modifica'">
                                                    clicca per inserire il docente
                                                    <v-icon
                                                        color="blue"
                                                        small
                                                    >mdi-plus</v-icon>
                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div v-if="ida===0" :class="['daychange calendar-row ',idx>0?'border-top-1':'']"
                                     :style="'width:'+(250+(countOrari*200))+'px;'">
                                    <div class="cella-2 cal-primary activableCell">
                                        <div class="aula headcell">{{ aula.nome }}</div>
                                        <div class="aula-line" :style="'background-color:'+aula.colore">&nbsp;</div>
                                    </div>
                                    <div v-for="(_item,iTimedx) in countOrari" :key="idx+'_'+ida+'_na_row_'+iTimedx"
                                         class="cella-1 activableCell">
                                        <div class="aula celladocente aula_idx0"
                                             :data-dayKey="giorno.dayKey"
                                             :data-timeKey="iTimedx"
                                             :data-timeValue="orariAtIndex(iTimedx)"
                                             v-on:click="impostaDocente(giorno,orariAtIndex(iTimedx),aula.id)">
                                            <div
                                                :class="['cella',(giorno.issunday===false&&giorno.isholiday===false&&modo==='modifica'?'active':'')]"
                                                v-if='calendario[giorno.dayKey+" "+orariAtIndex(iTimedx)+" "+aula.id]'>
                                                <span class="modulo inm"
                                                      v-if='calendario[giorno.dayKey + " " + orariAtIndex(iTimedx)+" "+aula.id].modulo&&
                                                          calendario[giorno.dayKey + " " + orariAtIndex(iTimedx)+" "+aula.id].modulo.modulo'>
                                                {{
                                                        calendario[giorno.dayKey + " " + orariAtIndex(iTimedx) + ' ' + aula.id].modulo.modulo
                                                    }}
                                                </span>
                                                <span class="docente ind"
                                                      v-if="calendario[giorno.dayKey + ' ' + orariAtIndex(iTimedx)+' '+aula.id].docente">
                                                {{
                                                        calendario[giorno.dayKey + " " + orariAtIndex(iTimedx) + ' ' + aula.id].docente.full_name
                                                    }}
                                                </span>
                                                <span class="tutor" v-if="calendario[giorno.dayKey + ' ' + orariAtIndex(iTimedx)+' '+aula.id].tutor">
                                                    Tutor: <span>{{calendario[giorno.dayKey + ' ' + orariAtIndex(iTimedx)+' '+aula.id].tutor.full_name}}</span>
                                                </span>
                                                <span class="codocente" v-if="calendario[giorno.dayKey + ' ' + orariAtIndex(iTimedx)+' '+aula.id].codocente">
                                                    Co-docente: <span>{{calendario[giorno.dayKey + ' ' + orariAtIndex(iTimedx)+' '+aula.id].codocente.full_name}}</span>
                                                </span>
                                            </div>
                                            <div v-else
                                                 :class="['cella',(giorno.issunday===false&&giorno.isholiday===false&&modo==='modifica'?'empty-active':'')]">
                                                <span class="empty-type" v-if="modo==='modifica'">
                                                    clicca per inserire il docente
                                                    <v-icon
                                                        color="blue"
                                                        small
                                                    >mdi-plus</v-icon>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else
                                     :class="['dayinner calendar-row border-bottom-1 border-light',idx>0?'border-top-1':'']"
                                     :style="'width:'+(250+(countOrari*200))+'px;'">
                                    <div class="cella-2 cal-primary activableCell">
                                        <div class="aula headcell">{{ aula.nome }}</div>
                                        <div class="aula-line" :style="'background-color:'+aula.colore">&nbsp;</div>
                                    </div>
                                    <div v-for="(_item,iTimedx) in countOrari" :key="idx+'_'+ida+'_dd_row_'+iTimedx"
                                         class="cella-1">
                                        <div class="aula celladocente aula_idxp activableCell"
                                             v-on:click="impostaDocente(giorno,orariAtIndex(iTimedx),aula.id)">
                                            <div
                                                :class="['cella',(giorno.issunday===false&&giorno.isholiday===false&&modo==='modifica'?'active':'')]"
                                                v-if='calendario[giorno.dayKey+" "+orariAtIndex(iTimedx)+" "+aula.id]'>
                                                <span class="modulo inm"
                                                      v-if='calendario[giorno.dayKey + " " + orariAtIndex(iTimedx)+" "+aula.id].modulo&&
                                                          calendario[giorno.dayKey + " " + orariAtIndex(iTimedx)+" "+aula.id].modulo.modulo'>
                                                {{
                                                        calendario[giorno.dayKey + " " + orariAtIndex(iTimedx) + ' ' + aula.id].modulo.modulo
                                                    }}
                                                </span>
                                                <span class="docente ind"
                                                      v-if="calendario[giorno.dayKey + ' ' + orariAtIndex(iTimedx)+' '+aula.id].docente">
                                                {{
                                                        calendario[giorno.dayKey + " " + orariAtIndex(iTimedx) + ' ' + aula.id].docente.full_name
                                                    }}
                                                </span>
                                                <span class="tutor" v-if="calendario[giorno.dayKey + ' ' + orariAtIndex(iTimedx)+' '+aula.id].tutor">
                                                    Tutor: <span>{{calendario[giorno.dayKey + ' ' + orariAtIndex(iTimedx)+' '+aula.id].tutor.full_name}}</span>
                                                </span>
                                                <span class="codocente" v-if="calendario[giorno.dayKey + ' ' + orariAtIndex(iTimedx)+' '+aula.id].codocente">
                                                    Co-docente: <span>{{calendario[giorno.dayKey + ' ' + orariAtIndex(iTimedx)+' '+aula.id].codocente.full_name}}</span>
                                                </span>
                                            </div>
                                            <div v-else
                                                 :class="['cella',(giorno.issunday===false&&giorno.isholiday===false&&modo==='modifica'?'empty-active':'')]">
                                                <span class="empty-type" v-if="modo==='modifica'">
                                                    clicca per inserire il docente
                                                    <v-icon
                                                        color="blue"
                                                        small
                                                    >mdi-plus</v-icon>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                </div>
            </v-col>
            <v-col :cols="12" v-else>
                <div class="calendario-size text-center bold">{{ warncalendar }}</div>
            </v-col>
        </v-row>
        <v-dialog v-model="dialogInfo"
                  max-width="70%">
            <v-card class="mx-auto">
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline">
                            {{ corsodata.nome }}
                        </v-list-item-title>
                        <v-list-item-subtitle>{{ corsodata.progetto }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-card-text>
                    <v-row align="center">
                        <v-col
                            cols="6" class="mb-0 pb-0"
                        >
                            Iniziato il <b>{{ formatTime(corsodata.inizio) }}</b>
                        </v-col>
                        <v-col cols="6" class="mb-0 pb-0">
                            Previsione fine il <b>{{ formatTime(corsodata.fine) }}</b>
                        </v-col>
                        <v-col
                            cols="6" class="mb-0 pb-0">
                            Ore calendarizzate <b>{{ corsodata.calendartotal }}</b>
                        </v-col>
                        <v-col cols="6" class="mb-0 pb-0">
                            Ore totali <b>{{ corsodata.ore }}</b>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-container fluid>
                    <v-row wrap no-gutters v-for="(item,idx) in corsodata.articolazione"
                           :key="item.modulo_id+'_'+item.docente_id" align='center' dense
                           :class="['zebra',(idx%2>0?'odd':'even')]"
                    >
                        <v-col :cols="5" class="mb-0 pb-1">
                            <div class="text-h6">{{ item.modulo }}</div>
                            <div class="text-subtitle-2">{{ item.docente }}</div>
                        </v-col>
                        <v-col :cols="2" class="mb-0 pb-1">Primo ingresso: <b>{{ formatTime(item.inizio) }}</b></v-col>
                        <v-col :cols="2" class="mb-0 pb-1">Ultimo: <b>{{ formatTime(item.ultima) }}</b></v-col>
                        <v-col :cols="3" class="mb-0 pb-1 text-h6"><b>{{ item.oresvolte }}</b><small>/{{
                                item.assegnate
                            }}</small></v-col>
                    </v-row>
                </v-container>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="dialogInfo = false"
                    >
                        Chiudi
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialog"
            max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    Vuoi rimuovere questa pianificazione?
                </v-card-title>

                <v-card-text>
                    Sei sicuro di vole rimuovere questa pianificazione?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        color="green darken-1"
                        text
                        @click="dialog = false"
                    >
                        Annulla
                    </v-btn>

                    <v-btn
                        color="res darken-1"
                        text
                        @click="confirmRemove"
                    >
                        Si, rimuovi
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialogAvailability"
            max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    Attenzione
                </v-card-title>

                <v-card-text>
                    Il docente non ha confermato la propria disponibilità per questo intervallo giorno/ora.<br/>
                    Pertanto potrebbe non essere disponibile.<br/>
                    Vuoi assegnarlo comunque?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        color="green darken-1"
                        text
                        @click="dialogAvailability = false"
                    >
                        Annulla
                    </v-btn>

                    <v-btn
                        color="res darken-1"
                        text
                        @click="confirmAssign"
                    >
                        Si, assegna
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import debounce from 'debounce'

var moment = require('moment');
moment.locale("it");
var axios = require('axios');
export default {
    props: {
        vacations: {
            type: Array,
            default: () => []
        },
        chiave: {
            type: String,
            default: "v0"
        },
        minora: {
            type: String,
            default: "08:00:00"
        },
        maxora: {
            type: String,
            default: "14:00:00"
        },
        moduliurl: "",
        docentiurl: "",
        codocentiurl: "",
        postcalendarurl: "",
        calendarurl: "",
        docenteimpegniurl: "",
        startmoduli: {
            type: Array,
            default: () => []
        },
        aule: {
            type: Array,
            default: () => []
        },
        tutors: {
            type: Array,
            default: () => []
        },

        startcorsodata: {
            type: Object,
            default: () => {
            }
        }
    },
    data() {
        return {
            corsodata: {},
            moduli: [],
            dialogInfo: false,
            dialog: false,
            dialogAvailability: false,
            tempAssignment: null,
            tempRemove: null,
            wrapWidth: '0px',
            "weekdays": [
                {"weekday": 0, "name": 'Lun'},
                {"weekday": 1, "name": 'Mar'},
                {"weekday": 2, "name": 'Mer'},
                {"weekday": 3, "name": 'Gio'},
                {"weekday": 4, "name": 'Ven'},
                {"weekday": 5, "name": 'Sab'}
            ],
            "modo": "consultazione",
            "docenti": [],
            "codocenti": [],
            searchCodocente: null,
            loadingCodocenti: false,
            "dateRange": null,
            "dataWeek": [
                {"weekday": 0, "name": 'Lunedì'},
                {"weekday": 1, "name": 'Martedì'},
                {"weekday": 2, "name": 'Mercoledì'},
                {"weekday": 3, "name": 'Giovedì'},
                {"weekday": 4, "name": 'Venerdì'}
            ],
            "dataAula": [],
            "current_docente": null,
            "current_modulo": null,
            "current_codocente": null,
            "current_tutor": null,
            "doc_search": null,
            "warn": "",
            listRendered: false,
            "warncalendar": 'Scegli un periodo',
            masks: {
                input: 'DD/MM/YYYY',
            },
            "orari": [],
            "giornate": [],
            "calendario": {},
            "availability": [],
            "teacherplanning": [], //Contenitore generale
            "teacherPlanCache": {}, //Cache dei calcoli già effettuati circa la disponibilità - da svuotare ogni cambio docente.


        }
    },
    methods: {
        orariAtIndex(index) {
            let _idx = parseInt(index);
            if (isNaN(_idx)) {
                return this.orari[0];
            }
            _idx = Math.max(0, _idx);
            if (_idx >= this.orari.length) {
                return this.orari[0];
            }
            return this.orari[_idx];
        },
        mostraInfoCorso() {
            this.dialogInfo = true;
        },
        secondsSinceMidnight(timeString) {
            if (!timeString) {
                return null;
            }
            let pieces = timeString.split(':');
            let hours = pieces.length >= 1 ? parseInt(pieces[0]) : 0;
            let minutes = pieces.length >= 2 ? parseInt(pieces[1]) : 0;
            return (hours * 3600) + (minutes * 60);
        },
        isTeacherPlan(day, orario) {
            if (this.teacherplanning.length === 0) {
                return false; //Se non ci sono risultati, non mostrare il tooltip
            }
            if (typeof this.teacherPlanCache[day + "_" + orario] !== 'undefined') {
                return !(this.teacherPlanCache[day + "_" + orario]);
            }
            let dayMoment = moment(day);
            let weekDay = dayMoment.isoWeekday() - 1; //Normalizza iso WeekDay
            let time = parseInt(orario) * 3600; //secondi dalla mezzanotte
            let availability = [];
            this.teacherplanning.map((plan, indice) => {
                //Casi data dal / al intervallo incluso
                let dStart = plan.disponibile_dalday ? moment(plan.disponibile_dalday) : null;
                let dEnd = plan.disponibile_alday ? moment(plan.disponibile_alday) : null;
                let tStart = plan.disponibile_daltime ? this.secondsSinceMidnight(plan.disponibile_daltime) : null;
                let tEnd = plan.disponibile_altime ? this.secondsSinceMidnight(plan.disponibile_altime) : null;
                let weekDays = plan.weekday;
                let inDayRange = null;
                let inTimeRange = null;
                let inWeekRange = null;
                if (weekDays.length > 0) {
                    inWeekRange = weekDays.filter((v) => v === weekDay).length > 0;
                } else {
                    inWeekRange = true; //Se nullo o conteggio zero è sempre in range...
                }
                //WeekDay in intervallo
                if (null !== dStart && null !== dEnd) {
                    inDayRange = (dayMoment.isSameOrAfter(dStart) && dayMoment.isBefore(dEnd));
                } else if (dStart !== null && dEnd === null) {
                    inDayRange = dayMoment.isSameOrAfter(dStart);
                } else if (dStart === null && dEnd !== null) {
                    inDayRange = dayMoment.isBefore(dEnd);
                }
                //ORario incluso (maggiore, minore o incluso
                if (null !== tStart && null !== tEnd) {
                    inTimeRange = (time >= tStart && time < tEnd);
                } else if (tStart !== null && tEnd === null) {
                    inTimeRange = time >= tStart;
                } else if (tStart === null && tEnd !== null) {
                    inTimeRange = time <= tEnd;
                }
                if (inDayRange != null && inWeekRange !== null && inTimeRange !== null) {
                    availability.push(inDayRange && inWeekRange && inTimeRange);
                    return; //se sono tutti diversi da nullo, deve soddisfare tutti e tre.
                } else if (inDayRange != null && inWeekRange !== null && inTimeRange === null) {
                    availability.push(inDayRange && inWeekRange); //se sono tutti diversi da nullo, deve soddisfare tutti e due.
                    return;
                } else if (inDayRange != null && inWeekRange === null && inTimeRange !== null) {
                    availability.push(inDayRange && inTimeRange); //se sono tutti diversi da nullo, deve soddisfare tutti e due.
                    return;
                } else if (inDayRange == null && inWeekRange !== null && inTimeRange !== null) {
                    availability.push(inWeekRange && inTimeRange); //se sono tutti diversi da nullo, deve soddisfare tutti e due.
                    return;
                } else {
                    if (inDayRange !== null) {
                        //Giornata non disponibile;
                        availability.push(inDayRange);
                    }
                    if (inTimeRange !== null) {
                        //Orario non disponibile;
                        availability.push(inTimeRange);
                    }
                    if (inWeekRange !== null) {
                        //WeekDay non disponibile;
                        availability.push(inWeekRange);
                    }
                }
            });
            let isAvailable = availability.filter((v) => v === true).length > 0; //Almeno 1 deve rispondere true
            this.$set(this.teacherPlanCache, day + "_" + orario, isAvailable);
            return !isAvailable; //se disponibile === true;
        },
        formatTime(time) {
            let m = moment(time);
            return m.format('L');
        },
        moduleFilter(item, queryText, itemText) {
            const textOne = item.modulo.toLowerCase()
            const searchText = queryText.toLowerCase()

            return textOne.indexOf(searchText) > -1
        },
        codocenteFilter(item, queryText, itemText) {
            const textOne = item.full_name.toLowerCase()
            const searchText = queryText.toLowerCase()
            return textOne.indexOf(searchText) > -1
        },
        teacherFilter(item, queryText, itemText) {
            const textOne = item.full_name.toLowerCase()
            const searchText = queryText.toLowerCase()
            return textOne.indexOf(searchText) > -1
        },
        prepareCalendarForDisplay(data) {
            this.$set(this, 'calendario', {});
            if (!data) {
                return;
            }
            if (typeof data === 'undefined') {
                return;
            }
            Object.keys(data).forEach((k) => {
                let objKey = k;
                let item = data[k];
                let objDoc = {
                    "fullday": item.fullday,
                    "aula": {
                        "nome": (item.aula ? item.aula : item.aula_id),
                        "id": item.aula_id
                    },
                    "docente": {
                        "full_name": (item.docente ? item.docente : item.docente_id),
                        "id": item.docente_id
                    },
                    "tutor": {
                        "full_name": (item.tutor ? item.tutor : item.tutor_id),
                        "id": item.tutor_id
                    },
                    "codocente": {
                        "full_name": (item.codocente ? item.codocente : item.codocente_id),
                        "id": item.codocente_id
                    },
                    "modulo": {
                        "modulo": (item.modulo ? item.modulo : item.modulo_id),
                        "id": item.modulo_id
                    },
                    "supplente": {
                        "supplente": (item.supplente ? item.supplente : item.supplente_id),
                        "id": item.supplente_id
                    },
                    "time": item.in,
                    "loaded": true
                };
                if (
                    !objDoc?.tutor?.id ||
                    Number(objDoc.tutor.id) <= 0
                )  {
                    objDoc['tutor']['full_name']="Nessun tutor";
                }
                if (
                    !objDoc?.codocente?.id ||
                    Number(objDoc.codocente.id) <= 0
                ) {
                    objDoc['codocente']['full_name']="Nessun co-docente";
                }

                this.$set(this.calendario, objKey, objDoc);
            });
        },
        isHoliday(date) {
            let ish = this.vacations.filter((v) => {
                let yearCheck = (v.year === null ? date.year() : v.year);
                let monthCheck = (v.month === null ? (date.month() + 1) : v.month);
                let dayCheck = (v.day === null ? date.date() : v.day);
                return yearCheck === date.year() &&
                    monthCheck === (date.month() + 1) &&
                    dayCheck === date.date();
            });
            console.log('got', ish);
            return ish.length > 0;
        },
        dateRangeChange: function () {
            console.log('ottengo', this.dateRange);
            this.$set(this, 'giornate', []);
            this.listRendered = false;
            $('.calendario-wrapper').unbind('scroll');
            if (this.dateRange && typeof this.dateRange.start !== 'undefined') {
                let start = moment(this.dateRange.start);
                let end = moment(this.dateRange.end);
                this.$set(this, 'calendario', {});
                let current = start.clone();
                while (current.isBefore(end)) {
                    let gg = current.clone();
                    let isoWeek = gg.isoWeekday();
                    if (this.dataWeek.filter((v) => (v.weekday + 1) === isoWeek).length === 0 && isoWeek < 7) {
                        current.add(1, 'days');
                        continue;
                    }
                    this.giornate.push({
                        'issunday': isoWeek === 7,
                        'isholiday': this.isHoliday(gg.clone()),
                        'dayKey': gg.format('YYYY-MM-DD'),
                        'dayHuman': gg.format('DD/MM'),
                        'dayWeek': gg.format('ddd')
                    });
                    for (let i = this.minora; i <= this.maxora; i++) {
                        this.$set(this.calendario, gg.format('YYYY-MM-DD') + " " + i, false);
                    }
                    current.add(1, 'days');
                }
                //Mostra loading
                this.$isLoading(true);
                //Carica calendario per il periodo
                var params = {
                    dateFrom: this.dateRange.start,
                    dateTo: this.dateRange.end,
                    weekDays: this.dataWeek,
                    aule: this.dataAula
                };

                let cacheKey = this.chiave+"calendario_by_" + this.$root.generateUniqueHash(params);
                let hasCalendarCached = this.$root.retrieveObject(cacheKey);
                if (null !== hasCalendarCached) {
                    console.log('read calendar by cache', cacheKey, hasCalendarCached);
                    new Promise((resolve, reject) => {
                        this.prepareCalendarForDisplay(hasCalendarCached);
                        resolve(true);
                    }).finally(() => {
                        this.$isLoading(false);
                        this.listRendered = true;
                        this.$nextTick((v) => {
                            setTimeout(function () {
                                $('.calendario-wrapper').bind('scroll', function () {
                                    let scrollo = -1 * ($(this).scrollLeft());
                                    let _scrollo = -1 * (scrollo);
                                    $('.calendar-row.header.sticked').css({
                                        'transform': 'translateX(' + scrollo + 'px)'
                                    });
                                    $('.calendar-row.sticked_line').css({
                                        'transform': 'translateX(' + scrollo + 'px)'
                                    });
                                    $('.headinfo').css({
                                        'transform': 'translateX(' + _scrollo + 'px)'
                                    });
                                });
                                window.refreshSticky();
                            }, 500);
                        });
                    });
                } else {
                    console.log('read calendar by axios', this.calendarurl, params);
                    axios
                        .post(this.calendarurl, params)
                        .then(response => {
                            //Per ogni situazione, imposta il giorno...
                            if (response && response.data && response.data.results) {
                                this.prepareCalendarForDisplay(response.data.results);
                                this.$root.storeObject(cacheKey, response.data.results, 300); //Solo per 5 minuti
                            }
                        }).catch(error => {

                    }).finally(() => {
                        this.$isLoading(false);
                        this.listRendered = true;
                        this.$nextTick((v) => {
                            setTimeout(function () {
                                $('.calendario-wrapper').bind('scroll', function () {
                                    let scrollo = -1 * ($(this).scrollLeft());
                                    let _scrollo = -1 * (scrollo);
                                    $('.calendar-row.header.sticked').css({
                                        'transform': 'translateX(' + scrollo + 'px)'
                                    });
                                    $('.calendar-row.sticked_line').css({
                                        'transform': 'translateX(' + scrollo + 'px)'
                                    });
                                    $('.headinfo').css({
                                        'transform': 'translateX(' + _scrollo + 'px)'
                                    });
                                });
                                window.refreshSticky();
                            }, 500);
                        });
                    });
                    //Nascondi loading
                }

            }
        },
        selectAllDays: function () {
            this.$nextTick(() => {
                if (this.likeAllWeekDays) {
                    this.dataWeek = []
                } else {
                    this.dataWeek = this.weekdays.slice()
                }
                this.dateRangeChange();
            });
        },
        selectAllAule: function () {
            this.$nextTick(() => {
                if (this.likeAllRooms) {
                    this.dataAula = []
                } else {
                    this.dataAula = this.aule.slice()
                }
                this.dateRangeChange();
            });
        },
        generaDisponibilita(day, time) {
            if (this.modo !== 'modifica') {
                return "readonly";
            }
            let dayKey = day;
            //availability
            if (typeof this.availability[dayKey] !== 'undefined') {
                if (typeof this.availability[dayKey][time] !== 'undefined') {
                    return "notavailable";
                }
            }
            if (this.calendario[day + " " + time] !== false) {
                return "occupy";
            }
            return "active";
        },
        impostaDocente(dayObject, time, aula) {
            let day = dayObject.dayKey;
            if (this.modo !== 'modifica') {
                toastr.info('Imposta il metodo "Modifica", per variare il calendario.');
                return;
            }
            if (dayObject.issunday || dayObject.isholiday) {
                toastr.info('Impossibile assegnare il docente: il giorno è Festivo');
                return;
            }
            console.log('check calendar key: ', day + " " + time + " " + aula);
            if (
                typeof this.calendario[day + " " + time + " " + aula] === 'undefined' ||
                this.calendario[day + " " + time + " " + aula] === false
            ) {
                if (!this.current_docente) {
                    toastr.error('Attenzione nessun docente selezionato');
                    return;
                }
                if (typeof (this.availability[day + " " + time]) !== 'undefined') {
                    toastr.error('Attenzione il docente è già impegnato in altro corso.');
                    return;
                }
                //Primo check verifica se l'intervallo è già occupato:
                let isPlanned = this.aule.reduce((carry, _aula) => {
                    if (
                        typeof this.calendario[day + " " + time + " " + _aula.id] === 'undefined' ||
                        this.calendario[day + " " + time + " " + _aula.id] === false
                    ) {
                        return carry;
                    } else {
                        return true;
                    }
                }, false);
                if (isPlanned) {
                    toastr.error('Attenzione hai già pianificato il docente!');
                    return;
                }
                //Ottieni oggetto aula by ID:
                let findAula = this.aule.reduce((carry, _aula) => {
                    if (_aula.id === aula) {
                        return _aula;
                    }
                    return carry;
                }, null);
                //Verifica se il docente ha dato disponibilità, altrimenti mostra avviso:
                let isAvailable = !this.isTeacherPlan(day, time);


                if (!isAvailable) {
                    this.tempAssignment = {
                        'arrayKey': day + " " + time + " " + aula,
                        'object': {
                            "fullday": day,
                            "docente": this.current_docente,
                            "codocente": this.current_codocente,
                            "tutor": this.current_tutor,
                            "aula": findAula,
                            "modulo": this.current_modulo,
                            "supplenza": null,
                            "time": time
                        }
                    };
                    this.dialogAvailability = true;
                    return;
                }
                if (this.current_docente.left_hours - 1 < 0) {
                    toastr.error('Attenzione tutte le ore del docente/modulo sono state inserite');
                    return;
                }
                //Imposta oggetto
                this.$set(this.calendario, day + " " + time + " " + aula, {
                    "fullday": day,
                    "docente": this.current_docente,
                    "codocente": this.current_codocente,
                    "tutor": this.current_tutor,
                    "aula": findAula,
                    "modulo": this.current_modulo,
                    "supplenza": null,
                    "time": time
                });
                this.updateCalendar(day);
                //Aggiorna le ore disponibili
                this.current_docente.left_hours = this.current_docente.left_hours - 1; //In tempo reale resetta le ore...
                //Avvia debounce di salvataggio giornata al result devi azzerare le seguenti cache: docente, availability, calendario
            } else {
                this.tempRemove = day + " " + time + " " + aula;
                this.dialog = true;
                return;
            }
        },
        confirmAssign() {
            if (this.tempAssignment) {
                this.$set(this.calendario, this.tempAssignment.arrayKey, this.tempAssignment.object);
                this.updateCalendar(this.tempAssignment.object.fullday);
                this.tempAssignment = null;
                this.dialogAvailability = false;
                this.current_docente.left_hours = this.current_docente.left_hours - 1; //In tempo reale resetta le ore...

            }
        },
        confirmRemove() {
            if (this.tempRemove) {
                if (typeof this.calendario[this.tempRemove] !== 'undefined') {
                    let check = this.calendario[this.tempRemove];
                    if (this.current_docente) {
                        if (check && check.docente.id === this.current_docente.id) {
                            this.current_docente.left_hours += 1;
                        }
                    }
                    this.updateCalendar(check.fullday);
                    this.$set(this.calendario, this.tempRemove, false);
                    this.tempRemove = null;
                    this.dialog = false;

                }
            }
        },
        updateCalendar: window.memoizeDebounce(function (giorno) {
            console.log('salvataggio giornata');
            toastr.info('Salvataggio ' + giorno + ' in corso...');
            let retrieveAllGiornoKeys = Object.keys(this.calendario).filter((gK) => gK.indexOf(giorno + " ") > -1);
            console.log('pronto a mandare update', retrieveAllGiornoKeys);
            let params = {
                "giorno": giorno,
                "corso": this.corsodata.id,
                "schedule": retrieveAllGiornoKeys.reduce((_obj, _key) => {
                    if (this.calendario[_key]) {
                        _obj[_key] = this.calendario[_key]; //Escludi i docenti rimossi
                    }
                    return _obj;
                }, {})
            }
            console.log('pronto in update', params);
            axios.post(this.postcalendarurl, params).then((r) => {
                if (r.data && r.data.success) {
                    toastr.success('' + giorno + ' salvato con successo');
                }
                console.log(r);
                return this.refreshModuli();
            }).catch((e) => {
                console.log('errore nel salvataggio calendario, ', e);
                toastr.error('Attenzione si è verificato un errore salvando ' + giorno + "");
            }).finally(() => {
                this.$isLoading(false);
            })
        }, 2000), /*invia richiesta di salvataggio dopo 2 sec */
        refreshModuli: function () {
            var url = this.moduliurl;
            const params = {}
            axios
                .post(url, params)
                .then(response => {
                    console.log('got response from refreshModuli', response.data)
                    if (response.data && response.data) {
                        if (typeof response.data['moduli'] !== 'undefined') {
                            this.moduli = response.data['moduli'];
                        }
                        if (typeof response.data['corsodata'] !== 'undefined') {
                            this.corsodata = response.data['corsodata'];
                        }
                    }
                }).catch(error => {
                console.log('impossibile fare refresh al corso', error)
            }).finally(() => {
                this.$isLoading(false);
            });
        },
        updateDocenti: _.debounce(function () {
            var url = this.docentiurl;
            this.$isLoading(true);
            var params = {
                term: "",
                modulo: this.current_modulo.id
            };
            let cacheKey = this.chiave+'docenti_list_by-' + this.current_modulo.id;
            let hasDocentiList = this.$root.retrieveObject(cacheKey);
            if (null !== hasDocentiList) {
                this.$set(this, 'docenti', hasDocentiList);
                this.$isLoading(false);
                return;
            }
            axios
                .post(url, params)
                .then(response => {
                    if (response.data && response.data.results && Array.isArray(response.data.results)) {
                        this.$root.storeObject(cacheKey, response.data.results, 3600); //conserva per 1h
                        this.docenti = response.data.results;
                    }
                }).catch(error => {
                this.$set(this, 'docenti', []);
            }).finally(() => {
                this.$isLoading(false);
            });
        }, 200),
        verificaWarning: _.debounce(function () {
            let warning = [];
            if (this.dateRange && typeof this.dateRange !== 'undefined') {
                if (this.dateRange.start && typeof this.dateRange.start !== 'undefined') {

                } else {
                    warning.push("Seleziona un intervallo di date valido");
                }
                if (this.dateRange.end && typeof this.dateRange.end !== 'undefined') {

                } else {
                    warning.push("Seleziona un intervallo di date valido");
                }
            } else {
                warning.push("Seleziona un intervallo di date valido");
            }
            if (this.current_modulo && typeof this.current_modulo.id !== 'undefined') {

            } else {
                warning.push("Seleziona un modulo");
            }
            if (this.current_docente && typeof this.current_docente.id !== 'undefined') {

            } else {
                warning.push("Seleziona un docente");
            }
            this.warn = warning.join(", ");
        }, 200),
        caricaDocente: _.debounce(function () {
            if (this.current_modulo && typeof this.current_modulo.id !== 'undefined') {
                if (this.current_docente && typeof this.current_docente.id !== 'undefined') {
                    this.generaDisponibilitaDocente();
                }
            }
        }, 200),
        fetchCodocenti(query) {
            this.loadingCodocenti = true;
            axios.post(this.codocentiurl, {term: query})
                .then(response => {
                    if (response.data && Array.isArray(response.data.results)) {
                        this.codocenti = response.data.results;
                    } else {
                        this.codocenti = [];
                    }
                })
                .catch(() => {
                    this.codocenti = [];
                })
                .finally(() => {
                    this.loadingCodocenti = false;
                });
        },
        generaDisponibilitaDocente: function () {
            this.verificaWarning();
            if (typeof this.dateRange === 'undefined') {
                return;
            }
            if (typeof this.dateRange.start === 'undefined') {
                return;
            }
            if (typeof this.dateRange.end === 'undefined') {
                return;
            }
            if (typeof this.current_docente === 'undefined') {
                return;
            }
            if (typeof this.current_docente.id === 'undefined') {
                return;
            }
            //Api per ottenere impegni del docente ovunque nel periodo richiesto
            //Api per ottenere l'oggetto disponibilità del docente
            //Mostra loading
            this.$isLoading(true);
            //Carica calendario per il periodo
            var params = {
                dateFrom: this.dateRange.start,
                dateTo: this.dateRange.end,
                teacher: this.current_docente.id
            };
            this.$set(this, 'availability', []);
            this.$set(this, 'teacherplanning', []);
            let cacheKey = this.chiave+"docenti_availability_by_" + this.current_docente.id + "_" + this.$root.generateUniqueHash(params);
            let availCache = this.$root.retrieveObject(cacheKey);
            if (null !== availCache) {
                this.$set(this, 'availability', availCache.availability);
                this.$set(this, 'teacherplanning', availCache.teacherplanning);
                this.$isLoading(false);
                this.$nextTick(() => {
                    window.refreshSticky();
                });
                return;
            }
            axios
                .post(this.docenteimpegniurl, params)
                .then(response => {
                    //Per ogni situazione, imposta il giorno...
                    if (response && response.data) {
                        if (response.data.results) {
                            this.$set(this, 'availability', response.data.results);
                        }
                        if (response.data.availability) {
                            this.$set(this, 'teacherplanning', response.data.availability);
                        }
                        this.$root.storeObject(cacheKey, {
                            availability: response.data.results || [],
                            teacherplanning: response.data.availability || []
                        }, 300); //Conserva i dati per 5 minuti...
                    }
                }).catch(error => {

            }).finally(() => {
                this.$isLoading(false);
                this.$nextTick(() => {
                    window.refreshSticky();
                });
            });
        },
        retrieveTimeObject(time, defaultTime) {
            let _time = time;
            if (_time.length <= 0) {
                _time = defaultTime;
            }

            let timeParts = _time.split(':').map((i) => parseInt(i));
            let dt = new Date();
            dt.setHours(timeParts[0], timeParts[1], timeParts[2]);
            return dt;
        },
        updateWrapperSize() {
            const _container = document.querySelector('.contenitore-calendario');
            if (_container) {
                const _box = _container.getBoundingClientRect().width;
                console.log('got new Size: ', _box);
                if (_box > 0) {
                    this.wrapWidth = _box + "px";
                } else {
                    this.wrapWidth = "100%";
                }
            }
        }
    },
    computed: {

        likeAllWeekDays() {
            return this.dataWeek.length === this.weekdays.length
        },
        likesSomeWeekDays() {
            return this.dataWeek.length > 0 && !this.likeAllWeekDays
        },
        likeAllRooms() {
            return this.dataAula.length === this.aule.length
        },
        likesSomeRooms() {
            return this.dataAula.length > 0 && !this.likeAllRooms
        },
        iconWD() {
            if (this.likeAllWeekDays) return 'mdi-close-box'
            if (this.likesSomeWeekDays) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        iconAule() {
            if (this.likeAllRooms) return 'mdi-close-box'
            if (this.likesSomeRooms) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        countOrari() {
            return Math.max(0, this.orari.length - 1);
        }
    },
    watch: {
        searchCodocente: _.debounce(function (val) {
            if (!val || val.length < 3) {
                this.codocenti = [];
                return;
            }
            this.fetchCodocenti(val);
        }, 300),
        "modo": function () {
            this.$nextTick(() => {
                window.refreshSticky();
            });
        },
        "current_modulo": function () {
            this.verificaWarning();
            this.updateDocenti();
        },
        "current_docente": function () {
            this.$set(this, 'teacherPlanCache', {});
            this.verificaWarning();
            this.caricaDocente();
        }
    },
    mounted() {
        if (this.startmoduli) {
            this.$set(this, 'moduli', this.startmoduli)
        }
        if (this.startcorsodata) {
            this.$set(this, 'corsodata', this.startcorsodata)
        }
        console.log('sono il calendario manager')
        $('#voyager-loader').remove();
        window.prova = this;
        const instance = this;
        let _minOra = (this.minora);
        let _maxOra = (this.maxora);

        let _startTime = this.retrieveTimeObject(_minOra, '08:00:00');//.getTime();
        let _endTime = this.retrieveTimeObject(_maxOra, '14:00:00');//.getTime();
        let _intime = _startTime.getTime();
        const _outtime = _endTime.getTime();

        while (_outtime >= _intime) {
            const dd = new Date(_intime);
            this.orari.push(dd.toLocaleTimeString().substring(0, 5));
            _intime += 3600 * 1000;
        }
        console.log('orari pronti', this.orari);
        this.updateWrapperSize();
        document.addEventListener('onresize', function () {
            console.log('cambio size');
            instance.updateWrapperSize();
            window.updateSticky();
        });
        document.addEventListener('movedFullScreen', function () {
            console.log('cambio fullscreen');
            instance.updateWrapperSize();
            window.updateSticky();

        });
        this.selectAllDays();
        this.selectAllAule();
        this.verificaWarning();

    }
}
</script>
